/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MeusDadosAliases {
  CARD_0 = 'card-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  FETCH = 'fetch',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FIELD_6 = 'field-6',
  FORM_0 = 'form-0',
  LAYOUT_MEUS_DADOS = 'layout-meus-dados',
  LINK_ALTERAR_SENHA = 'link-alterar-senha',
  LINK_PRIVACY = 'link-privacy',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PHONE_NUMBER_0 = 'phone-number-0',
  PHONE_NUMBER_1 = 'phone-number-1',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
}
export { MeusDadosAliases };
